import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Dispatchers_getInstanceitgtkvqfcnx3 as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveNotReadygki7zhqkkp9u as InternalReactiveNotReady,
  Companion_getInstance1a6q7ejsqzzhs as Companion_getInstance,
  _ReactiveState___init__impl__fvdp9b2eqyidpf491cp as _ReactiveState___init__impl__fvdp9b,
} from './ReactiveState.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { BaseReactive302n39o7i5yop as BaseReactive } from './abstracts.mjs';
import { RememberSuspending3811d1qplzllg as RememberSuspending } from './RememberSuspending.mjs';
import {
  lens2x0usmj7eco4 as lens,
  lens2po2j99uxhjgr as lens_0,
  set1ugseoes1jrmg as set,
  ReactiveWithMutableValue1h1r6ig7acce5 as ReactiveWithMutableValue,
} from './coreInterfaces.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function mutableRememberSuspending(useLastWhileLoading, coroutineContext, initialValue) {
  useLastWhileLoading = useLastWhileLoading === VOID ? false : useLastWhileLoading;
  coroutineContext = coroutineContext === VOID ? Dispatchers_getInstance().yac_1 : coroutineContext;
  return MutableRememberSuspending().ual(true, useLastWhileLoading, coroutineContext, null, initialValue);
}
function updateOnce($this) {
  var currentRememberedState = $this.sal_1.sah();
  var tmp;
  if (!$this.ral_1) {
    var tmp_0;
    if (!$this.qal_1) {
      tmp_0 = true;
    } else {
      // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
      var tmp_1 = _ReactiveState___get_raw__impl__92ipya(currentRememberedState);
      tmp_0 = !(tmp_1 instanceof InternalReactiveNotReady());
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  if (tmp) {
    $this.rah(currentRememberedState);
  }
}
function startListening($this) {
  var tmp = $this;
  tmp.tal_1 = $this.sal_1.vah(() => {
    var tmp;
    if (!$this.ral_1) {
      $this.rah($this.sal_1.sah());
      tmp = Unit_instance;
    }
    return Unit_instance;
  });
  updateOnce($this);
}
function stopListening($this) {
  var tmp0_safe_receiver = $this.tal_1;
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver();
  $this.tal_1 = null;
}
var MutableRememberSuspendingClass;
function MutableRememberSuspending() {
  if (MutableRememberSuspendingClass === VOID) {
    class $ extends BaseReactive() {
      static ual(stopListeningWhenOverridden, useLastWhileLoading, coroutineContext, deactivationDelay, initialValue) {
        stopListeningWhenOverridden = stopListeningWhenOverridden === VOID ? true : stopListeningWhenOverridden;
        useLastWhileLoading = useLastWhileLoading === VOID ? false : useLastWhileLoading;
        coroutineContext = coroutineContext === VOID ? Dispatchers_getInstance().yac_1 : coroutineContext;
        deactivationDelay = deactivationDelay === VOID ? null : deactivationDelay;
        var $this = this.ial();
        $this.pal_1 = stopListeningWhenOverridden;
        $this.qal_1 = useLastWhileLoading;
        $this.ral_1 = false;
        $this.sal_1 = RememberSuspending().fam(coroutineContext, $this.qal_1, deactivationDelay, initialValue);
        $this.tal_1 = null;
        return $this;
      }
      rah(value) {
        super.rah(value);
      }
      sah() {
        if (!this.ral_1 && this.tal_1 == null) {
          updateOnce(this);
        }
        return super.sah();
      }
      kal() {
        if (!this.ral_1 && this.tal_1 == null) {
          startListening(this);
        }
      }
      lal() {
        if (this.tal_1 == null)
          return Unit_instance;
        stopListening(this);
        if (!this.ral_1 && !this.qal_1) {
          this.rah(Companion_getInstance().oah_1);
        }
      }
      eak(value) {
        if (!this.ral_1) {
          this.ral_1 = true;
          if (this.pal_1) {
            stopListening(this);
          }
        }
        this.rah(_ReactiveState___init__impl__fvdp9b(value));
      }
    }
    protoOf($).vak = lens;
    protoOf($).dak = lens_0;
    protoOf($).iah = set;
    initMetadataForClass($, 'MutableRememberSuspending', VOID, VOID, [ReactiveWithMutableValue(), BaseReactive()], [1]);
    MutableRememberSuspendingClass = $;
  }
  return MutableRememberSuspendingClass;
}
//region block: exports
export {
  mutableRememberSuspending as mutableRememberSuspending34dudnx7ur0xn,
};
//endregion

//# sourceMappingURL=MutableRememberSuspending.mjs.map
